import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {OutletSearchModel} from "../outlet-search.model";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {OutletSearchPageComponent} from "../outlet-search-page/outlet-search-page.component";
import {OutletEditPageComponent} from "../outlet-edit-page/outlet-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-outlet-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(OutletSingleSelectEditControlComponent),
        provideSearchModel(OutletSearchModel)
    ]
})
export class OutletSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<OutletSearchModel> {
    constructor(model: OutletSearchModel, injector: Injector) {
        super(model, injector, "outletId", "name");

        this.extendedSearchComponent = OutletSearchPageComponent;
        this.extendedEditComponent = OutletEditPageComponent;
    }

    private _outletGroupId: number;

    get outletGroupId(): number {
        return this._outletGroupId;
    }

    @Input()
    set outletGroupId(value: number) {
        this._outletGroupId = value;
        this.model.setFilterValue("outletGroupId", value);
        if (value === undefined) {
            this.extendedSearchComponentParams = {};
            this.extendedEditComponentParams = {};
        } else {
            this.extendedSearchComponentParams = {"outletGroupId": value};
            this.extendedEditComponentParams = {"outletGroupId": value};
        }
    }
}
